export default __webpack_public_path__ + "static/media/10Klein.434da02e.jpg";